import { ErrorSurface } from '@/components/ErrorSurface'
import { getString } from '@/notFound/i18n/bundle.generated'

/**
 * Content-not-found page — mirrors green hornet's ErrorContentNotFound
 * (primary text + home link + search link + graphic). Rendered as the router
 * fallback for unknown paths and inlined by detail-page loaders that used to
 * redirect to `/` on an empty wire response.
 */
export function NotFoundPage() {
    return ErrorSurface({
        message: getString('dmusic_not_found_primary_text'),
        actions: [
            { href: '/', label: getString('dmusic_not_found_secondary_text_link') },
            { href: '/search', label: getString('dmusic_not_found_search_link') },
        ],
    })
}
